export type LiffHomeMenuVisibility = 'enabled' | 'disabled' | 'hidden';

export interface LiffHomeMenuQuickItem {
  key: string;
  route: string;
  nameTH: string;
  nameEN: string;
  image: string;
  alt: string;
  alert: string;
  action?: string;
  visibility: LiffHomeMenuVisibility;
  disableTextTH: string;
  disableTextEN: string;
  sortOrder: number;
}

export interface LiffHomeMenuMoreItem extends LiffHomeMenuQuickItem {
  imageSlide: string;
  imageActive: string;
}

export interface LiffHomeMenuCategory {
  categoryKey: string;
  categoryTH: string;
  categoryEN: string;
  sortOrder: number;
  items: LiffHomeMenuMoreItem[];
}

export interface LiffHomeMenuConfig {
  version: number;
  description?: string;
  /** Full inventory — Admin create/edit + Import; pick into Quick/More for LIFF Home */
  catalog?: LiffHomeMenuMoreItem[];
  quick: LiffHomeMenuQuickItem[];
  more: LiffHomeMenuCategory[];
}

export interface LiffHomeMenuConfigResponseDto {
  id?: number;
  Id?: number;
  isDefault?: boolean;
  IsDefault?: boolean;
  writeDate?: string | null;
  WriteDate?: string | null;
  config?: LiffHomeMenuConfig;
  Config?: LiffHomeMenuConfig;
}

export interface LiffHomeMenuConfigSavePayload {
  userId: number;
  menuId: number;
  config: LiffHomeMenuConfig;
}

export const LIFF_HOME_VISIBILITY_OPTIONS: { value: LiffHomeMenuVisibility; label: string }[] = [
  { value: 'enabled', label: 'เปิดใช้' },
  { value: 'disabled', label: 'ปิด (แสดงล็อก)' },
  { value: 'hidden', label: 'ซ่อน' },
];

export const LIFF_HOME_GLOBAL_CONFIG_ENTITY_ID = 1;

export const LIFF_HOME_QUICK_MAX_VISIBLE = 6;

/** Empty catalog item form — all LIFF-required fields present */
export function createEmptyLiffHomeMenuItem(): LiffHomeMenuMoreItem {
  return {
    key: '',
    route: '',
    nameTH: '',
    nameEN: '',
    image: '',
    imageSlide: '',
    imageActive: '',
    alt: '',
    alert: '',
    action: '',
    visibility: 'enabled',
    disableTextTH: 'ปิดปรับปรุง',
    disableTextEN: 'Coming soon',
    sortOrder: 0,
  };
}
